import { onUnmounted } from '@nuxtjs/composition-api';
/**
 * Widget Observer
 *
 * @param {Array} config Widget List
 *
 */
export const useWidgetObserver = (cb, config) => {
  const observerOptions = {
    rootMargin: '-30% 0% -50% 0%',
    threshold: 0.5,
  };

  const observer = new IntersectionObserver(cb, observerOptions);
  const target = '.homepage-widget-observer';
  document.querySelectorAll(target).forEach((i) => {
    if (i) {
      observer.observe(i);
    }
  });

  onUnmounted(() => {
    const target = '.homepage-widget-observer';
    document.querySelectorAll(target).forEach((i) => {
      if (i) {
        observer.unobserve(i);
      }
    });
  });
};
